import React from "react";
import Navigation from "../components/Navigation";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const ContactUs = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <div className="py-8">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Contact Us
          </h1>
          <p className="text-gray-600 mb-8 text-lg">
            Get in touch with us for product inquiries, quotes, or any questions.
          </p>
        </div>
      </div>
      <ContactSection />
      <Footer />
    </div>
  );
};

export default ContactUs;
